export default __webpack_public_path__ + "static/media/img7.c5eee4c8.jpg";